import React from 'react';
import { Image, Text, View } from 'react-native-web';
import LargeBtnWithFilling from '../ButtonComponent/LargeBtnWithFilling';
import { o_i_take_me_there } from '../../../../utils/DictionaryManagementUtils';
import { img_lock } from '../../../../utils/ImagesManagementUtils';
import { getBoldFont, getRegularFont, xlateText } from '../../../../utils/Utils';
import {
  textPrimary_11_0, textPrimary_14_0, textPrimary_8_7, textPrimary_9_3,
} from '../TextComponent/TextStyle';
//= ========================================================================

const HugeSquareWithTextAndBtn = ({
  globJSON,
  simPlatform,
  withOutParagraph,
  BtnInputText = o_i_take_me_there,
  is_step_1_of_2,
}) => {
  const { colors } = globJSON.configurations.theme;
  const { instructions } = globJSON.configurations.onboarding;
  const myStyles = {
    boxView: {
      width: 240,
      height: 222,
      borderTopLeftRadius: 6.7,
      borderTopRightRadius: 6.7,
      shadowColor: colors.primary_cta_color,
      shadowOffset: { width: 0, height: 0 },
      shadowOpacity: 0.12,
      shadowRadius: 6,
      backgroundColor: colors.app_background_color,
      textAlign: 'center',
      paddingVertical: 2,
      paddingHorizontal: 10,
    },
    stepTxtStyle: {
      alignSelf: 'center',
      fontFamily: `${getRegularFont(globJSON, simPlatform, true)}`,
      marginTop: 6,
      marginBottom: 4,
    },
    titleInsideBox: {
      width: 190,
      alignSelf: 'center',
      textAlign: 'center',
      paddingVertical: 10,
    },
    paragraphWithLochIcon: {
      paddingVertical: 12,
      alignItems: 'center',
      height: 16,
      flexDirection: 'row',
      alignSelf: 'center',
    },
    lockImageStyle: {
      width: 16,
      height: 16,
      tintColor: colors.primary_cta_color,
    },
    smallTitleStyle: {
      marginLeft: 4,
      marginTop: 4,
      textAlign: 'center',
      fontFamily: `${getBoldFont(globJSON, simPlatform, true)}`,
    },
    largeBtnStyle: {
      paddingVertical: 10,
    },
    heightOfEmptyView: {
      height: 48,
    },
  };
  return (
    <View style={myStyles.boxView}>
      <Text style={[textPrimary_9_3(globJSON, simPlatform), myStyles.stepTxtStyle]}>
        {is_step_1_of_2 ? instructions.o_i_step_1_of_2 : instructions.o_i_step_2_of_2}
      </Text>

      <Text style={[textPrimary_14_0(globJSON, simPlatform), myStyles.titleInsideBox]}>
        {xlateText(is_step_1_of_2 ? (instructions.o_i_enable_bank_keyboard_and) : (instructions.o_i_switch_to_bank_keyboard_and), globJSON)}
      </Text>
      {!withOutParagraph ? (
        <View>
          <View style={myStyles.paragraphWithLochIcon}>
            <Image
              fadeDuration={0}
              style={myStyles.lockImageStyle}
              source={img_lock}
            />
            <Text style={[textPrimary_9_3(globJSON, simPlatform), myStyles.smallTitleStyle]}>
              {xlateText(instructions.o_i_your_privacy_title, globJSON)}
            </Text>
          </View>
          <Text style={[textPrimary_8_7(globJSON, simPlatform), { textAlign: 'center' }]}>
            {xlateText(instructions.o_i_your_privacy, globJSON)}
          </Text>
        </View>
      ) : (<View style={myStyles.heightOfEmptyView} />)}
      <View style={myStyles.largeBtnStyle}>
        <LargeBtnWithFilling
          globJSON={globJSON}
          simPlatform={simPlatform}
          inputText={instructions[BtnInputText]}
          shortBtn
        />
      </View>
      <Text style={[textPrimary_11_0(globJSON, simPlatform), { alignSelf: 'center' }]}>
        {instructions.maybe_later}
      </Text>
    </View>
  );
};
export default HugeSquareWithTextAndBtn;
